export const modalities = [
    { value: null, label: null },
    { value: 'LOCATION', label: 'LOCAÇÃO' },
    { value: 'ACQUISITION', label: 'AQUISIÇÃO' },
    { value: 'DEMONSTRATION', label: 'DEMONSTRAÇÃO' },
    { value: 'DEVELOPMENT', label: 'DESENVOLVIMENTO' },
]